import * as ResultsProcessStatementTable from './ResultsProcessStatementTable';

export const ColumnCsvParser = {
  ResultsProcessStatementTable,

};
